import React from 'react';
import { Alert, AlertTitle } from '@material-ui/lab';

function DiemError() {
  return (
    <Alert severity="error">
      <AlertTitle>Error</AlertTitle>
      {'Cannot fetch view'}
    </Alert>
  );
}

export { DiemError };
